import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { availableReports } from '../../app/app.constants';
import { GlobalVars } from '../../app/app.environment';
import { Role } from '../../models/roles';

import { ReportGlobalPage } from '../report-global/report-global';
import { ReportMonthPage } from '../report-month/report-month';
import { ReportUserPage } from '../report-user/report-user';


@IonicPage()
@Component({
  selector: 'page-report-selection',
  templateUrl: 'report-selection.html',
})
export class ReportSelectionPage {

  isAdmin: boolean;
  list;

  // Evitar errors en app-scripts@3.2.4, d'aquesta forma importem les pàgines disponibles.
  availablePages = {
    'ReportGlobalPage': ReportGlobalPage,
    'ReportMonthPage': ReportMonthPage,
    'ReportUserPage': ReportUserPage
  }

  constructor(
    public globalVars: GlobalVars,
    public navCtrl: NavController,
    public navParams: NavParams
  ) {
    this.isAdmin = this.globalVars.user.role == Role['admin'];
    this.list = availableReports.filter(report => this.isAdmin >= report.admin);
  }

  goTo(selectedReport) {
    let page = this.availablePages[selectedReport.page]

    this.navCtrl.push(page);
  }

}


// WEBPACK FOOTER //
// ./src/pages/report-selection/report-selection.ts